// import axios from "axios";


var addCustomerRequest = (params) => axios._post(`/customer/add`, params); //添加客户需求信息
var getClassicVideo=(pageNum,pageSize)=>axios._get(`/classic/video/list?pageNum=${pageNum}&pageSize=${pageSize}`);//获取经典视频
var addJoinUs=(params)=>axios._post(`/join/us/add`,params);//添加加入我们 表单信息
var getLiveQrCode=()=>axios._get(`/live/qr/code/get/info`);//获取是否有视频直播参数
var getArticleTypeByCode=(code)=>axios._get(`/article/type/list/first/code?code=${code}`);//获取文章分类code 数据
var getArticleTypeFirst=(name,pageNum,pageSize)=>axios._get(`/article/type/first/list?name=${name}&pageNum=${pageNum}&pageSize=${pageSize}`);//获取文章一级分类
var getArticleByTypeList=(type,pageNum,pageSize)=>axios._get(`/article/list/type?categoryLevel2Id=${type}&state=1&pageNum=${pageNum}&pageSize=${pageSize}`);//获取分类下的文章列表
var getArticleInfo=(id)=>axios._get(`/article/info/font?id=${id}`);//获取文章详情
var getProductTypeList=(pageNum,pageSize)=>axios._get(`/product/type/list?pageNum=${pageNum}&pageSize=${pageSize}`);//获取产品分类列表
var getProductList=(typeId,pageNum,pageSize)=>axios._get(`/product/list/type?categoryLevel2Id=${typeId}&pageNum=${pageNum}&pageSize=${pageSize}`);//获取产品列表
var getProductDetail=(id)=>axios._get(`/product/detail?id=${id}`);//产品详情
var addConsultingProduct=(postData)=>axios._post(`/consulting/product/add`,postData);//添加商品询价表
export {
  addCustomerRequest,
  getClassicVideo,
  addJoinUs,
  getLiveQrCode,
  getArticleTypeByCode,
  getArticleTypeFirst,
  getArticleByTypeList,
  getProductTypeList,
  getProductList,
  getArticleInfo,
  getProductDetail,
  addConsultingProduct,
}



// WEBPACK FOOTER //
// ./src/service/service.js